const MASK_DIGIT_CHARS = new Set(["0", "9", "#"]);

export const parseInputMaskPattern = (pattern = "") =>
  String(pattern)
    .split("")
    .map((char) =>
      MASK_DIGIT_CHARS.has(char)
        ? { type: "digit" }
        : { type: "literal", char }
    );

export const getInputMaskDigitCapacity = (pattern) =>
  parseInputMaskPattern(pattern).filter((slot) => slot.type === "digit").length;

export const formatInputMaskDisplay = (digits = "", pattern = "", emptyChar = "0") => {
  const slots = parseInputMaskPattern(pattern);
  let digitIndex = 0;
  let result = "";

  slots.forEach((slot) => {
    if (slot.type === "literal") {
      result += slot.char;
      return;
    }
    result += digits[digitIndex] ?? emptyChar;
    digitIndex += 1;
  });

  return result;
};

export const formatInputMaskSubmitValue = (
  digits = "",
  pattern = "",
  submitFormat = "masked"
) => {
  if (submitFormat === "digits") {
    return digits;
  }

  const slots = parseInputMaskPattern(pattern);
  let digitIndex = 0;
  let result = "";

  slots.forEach((slot) => {
    if (slot.type === "literal") {
      result += slot.char;
      return;
    }
    result += digits[digitIndex] ?? "";
    digitIndex += 1;
  });

  return result;
};

export const isInputMaskComplete = (digits = "", pattern = "") =>
  digits.length === getInputMaskDigitCapacity(pattern);

export const maskPatternToValidationRegex = (pattern = "") => {
  let regex = "^";
  let digitRun = 0;

  for (const char of String(pattern)) {
    if (MASK_DIGIT_CHARS.has(char)) {
      digitRun += 1;
      continue;
    }

    if (digitRun > 0) {
      regex += `\\d{${digitRun}}`;
      digitRun = 0;
    }

    regex += char.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  if (digitRun > 0) {
    regex += `\\d{${digitRun}}`;
  }

  regex += "$";
  return new RegExp(regex);
};

/** Format a raw value (digits-only or already masked) using the given mask pattern. */
export const formatValueWithInputMask = (value, pattern = "") => {
  if (value == null || value === "" || !pattern) {
    return value;
  }

  const stringValue = String(value).trim();
  const validationRegex = maskPatternToValidationRegex(pattern);

  if (validationRegex.test(stringValue)) {
    return stringValue;
  }

  const digits = stringValue.replace(/\D/g, "");
  return formatInputMaskSubmitValue(digits, pattern, "masked");
};
